import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FertilizationDialogFields } from './main';

@Component({
	moduleId: module.id,
	selector: 'fertilizer-detail',
	templateUrl: 'fertilizer-detail.html',
	styleUrls: []
})

export class FertilizerDetailComponent implements OnInit, OnDestroy {
	protected _subscriptions$: Subject<boolean>;

	@Input()
	public form: FormGroup;

	public get f(): { [key in FertilizationDialogFields]: AbstractControl } {
		if (!this.form) {
			return null
		};

		return this.form.controls as { [key in FertilizationDialogFields]: AbstractControl };
	}

	constructor() {
	}

	ngOnInit(): void {
		this._subscriptions$ = new Subject();
	}

	ngOnDestroy(): void {
		if (!this._subscriptions$) {
			return;
		}

		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}
}
